import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskModule } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


import { SharedModule } from '@app/shared/shared.module';

import { AuthenticationLoginComponent } from './authentication-login/authentication-login.component';
import { AuthenticationRegisterComponent } from './authentication-register/authentication-register.component';
import { AuthenticationForgotPasswordComponent } from './authentication-forgot-password/authentication-forgot-password.component';
import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationComponent } from './authentication.component';
import { AutoFocus } from '@app/directives';
import { AuthenticationResetPasswordComponent } from './authentication-reset-password/authentication-reset-password.component';
import { AuthenticationRegisterDevComponent } from './authentication-register-dev/authentication-register-dev.component';
import { AuthenticationFirstScreenComponent } from './authentication-register-dev/authentication-first-screen/authentication-first-screen.component';
import { AuthenticationSecondScreenComponent } from './authentication-register-dev/authentication-second-screen/authentication-second-screen.component';

import 'compressorjs/dist/compressor';
import { FilePondModule, registerPlugin } from '@app/components/file-pond';

// import and register filepond file type validation plugin
import * as FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { InputFormComponent } from '@app/components';
import { CommonModule } from '@angular/common';

import { AuthenticationThirdScreenComponent } from './authentication-register-dev/authentication-third-screen/authentication-third-screen.component';
import { AuthenticationFourthScreenComponent } from './authentication-register-dev/authentication-fourth-screen/authentication-fourth-screen.component';
import { AuthenticationBannerComponent } from './authentication-banner/authentication-banner.component';
import { CarouselModule } from 'ngx-owl-carousel-o'

registerPlugin(FilePondPluginFileValidateType);


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule,
    MatButtonModule,
    FontAwesomeModule,
    AuthenticationRoutingModule,
    SharedModule,
    FilePondModule,
    InputFormComponent,
    MatRadioModule,
    MatSelectModule, 
    CarouselModule, 
  ],
  declarations: [
    AuthenticationComponent,
    AuthenticationLoginComponent,
    AuthenticationRegisterComponent,
    AuthenticationForgotPasswordComponent,
    AutoFocus,
    AuthenticationResetPasswordComponent,
    AuthenticationRegisterDevComponent,
    AuthenticationFirstScreenComponent,
    AuthenticationSecondScreenComponent,
    AuthenticationThirdScreenComponent,
    AuthenticationFourthScreenComponent, 
    AuthenticationBannerComponent, 
  ],
})
export class AuthenticationModule { }